import { Box } from '@mui/material';
import classes from './ExtractionCardLoadingContent.module.css';

export function ExtractionCardLoadingContent() {
  return (
    <Box className={classes.iconsContainer}>
      <img
        className={classes.icon}
        src="/images/icons/submissions/blank-doc.svg"
        alt="Blank Document Icon"
      />
      <img
        className={classes.icon}
        src="/images/icons/submissions/blank-doc.svg"
        alt="Blank Document Icon"
      />

      <img
        className={classes.loader}
        src="/images/loaders/Document-Extractor-Animation-Small.gif"
        alt="Extracting documents..."
      />

      <img
        className={classes.icon}
        src="/images/icons/submissions/blank-doc.svg"
        alt="Blank Document Icon"
      />
      <img
        className={classes.icon}
        src="/images/icons/submissions/blank-doc.svg"
        alt="Blank Document Icon"
      />
    </Box>
  );
}
